import React from 'react';

import './styles/bootstrap.scss';
import './styles/fonts.scss';
import './styles/carousel.scss';
import './styles/sh-shared.scss';
import './styles/index.scss';

/* eslint-disable import/default */

import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router, browserHistory} from 'react-router';
import routes from './routes';
import configureStore from './store/configureStore';
import {syncHistoryWithStore} from 'react-router-redux';

import 'zenscroll';
import '../public/js/collapse';
import '../public/js/jquery.maphilight';

const store = configureStore();
const history = syncHistoryWithStore(browserHistory, store);

ReactDOM.render(
  <Provider store={store}>
  <Router history={history} routes={routes}/>
</Provider>, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js